module.exports = __webpack_public_path__ + "img/202501_01.d66f036b.jpg";